import { API } from "../core/API";

const api = new API("/api/v1");

export const userService = {
    getAll: () => api.get("/users"),
    getById: (id) => api.get(`/users/${id}`),
    delete: (id) => api.delete(`/users/${id}`)
};
